import Sucursal from "./sucursal";

const sucursales = [
  {
    zone: "España",
    sucursales: [
      {
        location: "Málaga 1",
        address: "Calle Martínez 20",
        telephone: "60 244 8396",
      },
      {
        location: "Miramar Centro Comercial",
        address: "Avda. de la Encarnación, s/n, 29640 - Fuengirola",
        openAt: "Abierto todos los días",
        telephone: "722 37 39 16",
      },
      {
        location: "Marbella",
        address: "Calle Huerta Chica 1",
        telephone: "659 83 38 72",
        whatsappLink: "34659833872",
      },
      {
        location: "Vigo",
        address: "Calle Velázquez Moreno 23",
        telephone: "656 93 56 42",
        whatsappLink: "34656935642",
      },
      {
        location: "Madrid",
        address: "Corredera Baja de San Pablo 47",
        telephone: "609 37 11 03",
        whatsappLink: "34609371103",
      },
      {
        location: "Málaga 2",
        address: "Granada 48, Málaga",
        telephone: "60 244 8396",
        whatsappLink: "34602448396",
      },
      {
        location: "Palma de Mallorca",
        address: "Centro Comercial Porto Pi",
        telephone: "68 623 7544",
        whatsappLink: "34686237544",
      },
      {
        location: "La Pinocha CC Vialia - Vigo",
        address: "Praza Estación, 1, Santiago de Vigo, Pontevedra, Galicia",
        telephone: "65 192 2300",
        whatsappLink: "34651922300",
      },
    ],
  },
];


const Sucursales = () => {
  return (
    <div className="sucursales">
      <div className="top-section">
        <span className="familia-la-pinocha">Nuestras Sucursales</span>
        <span className="conoce-nuestra-historia-1">
          Estamos cerca, ¡visítanos!
        </span>
      </div>
      <div className="list-zones">
        {sucursales.map((sucursalZone) => {
          return (
            <div style={{ backgroundColor: sucursalZone.backgroundColor }}>
              <div className="sucursal-zone-box">
                <span className="sucursal-zone">{sucursalZone.zone}</span>
              </div>
              <div className="sucursal-list">
                {sucursalZone.sucursales.map((sucursal) => (
                  <Sucursal
                    address={sucursal.address}
                    locationName={sucursal.location}
                    openAt={sucursal.openAt}
                    telephone={sucursal.telephone}
                    whatsappLink={sucursal.whatsappLink}
                    style={sucursal.style}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sucursales;
